import { createContext, useReducer, useContext } from "react";
import todosReducer from "../reducers/todosReducer";

const ToDoContext = createContext([]);
const DispatchContext = createContext([]);

const ToDoProvider = ({ children }) => {
  const [toDos, dispatch] = useReducer(todosReducer, []);
  return (
    <ToDoContext.Provider value={toDos}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </ToDoContext.Provider>
  );
};
export const useToDos = () => {
  return useContext(ToDoContext);
};
export const useDispatch = () => {
  return useContext(DispatchContext);
};
export default ToDoProvider;
